import * as React from 'react'
import { getUrlParams } from '@src/utils';
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import qrcodeWx from '@assets/img/qrcodeWx.png'
import toWeappBj from '@assets/img/toWeappBj.png'
export default class JumpToWeApp extends ComponentExt<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            urlScheme: '',
            isCode: '',
            codeUrl: '',
        }
    }

    componentDidMount() {
        this.dongleGetControlFlag()
    };
    //新用户是否添加企微客服
    dongleGetControlFlag = async () => {
        try {
            const objUrl = getUrlParams();
            const res = await this.api.dongleGetControlFlag({})
            if (res == 'true') {
                this.getByCode(objUrl)
            } else {
                this.setState({ isCode: '0' })
                this.generatorSchema(objUrl)
            }
        } catch (error) {
        }
    }
    // 是否添加过企微客服
    getByCode = async (objUrl) => {
        try {
            const res = await this.api.getByCode({ sn: objUrl.sn })
            if (res.userId && res.externalUserId) {
                this.setState({ isCode: '0' })
                this.generatorSchema(objUrl)
            } else {
                await this.generateQrCode(objUrl.sn)
                this.setState({ isCode: '1' })
            }
        } catch (error) {
        }
    }
    //获取企微客服二维码
    generateQrCode = async (sn) => {
        try {
            const res = await this.api.generateQrCode({ state: sn })
            this.setState({ codeUrl: res })
        } catch (error) {

        }
    }
    toRealname = async () => {
        const objUrl = getUrlParams();
        const param = {
            type: objUrl.type,
            sn: objUrl.sn,
            path: '/verifyPackage/pages/chinaMobileAndTelecom/index/index'
        }
        const res = await this.api.generatorSchema(param);
        if (typeof res === 'object') {
            this.$toast.info('系统异常，无法跳转')
            return
        }
        location.href = res
    }
    generatorSchema = async (objUrl) => {
        try {
            const param = {
                type: objUrl.type,
                sn: objUrl.sn,
                path: '/verifyPackage/pages/chinaMobileAndTelecom/index/index'
            }
            const res = await this.api.generatorSchema(param);
            if (typeof res === 'object') {
                this.$toast.info('系统异常，无法跳转')
                return
            }
            await this.setState({
                urlScheme: res
            });
            location.href = res
        } catch (e) {
        }
    };
    toWeapp = () => {
        const isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i);
        if (!isMobile) {
            return this.$toast.info('请在手机打开网页链接')
        }
        const { urlScheme } = this.state;
        if (urlScheme) {
            location.href = urlScheme
        }
    }
    render() {
        if (!this.state.isCode) {
            return <></>
        }
        return (
            <>
                {this.state.isCode === '1' ? <div className={styles.wrap} style={{ backgroundImage: `url(${qrcodeWx})` }}>
                    <div className={styles.dongleText}>
                        <img className={styles.wxCode} src={this.state.codeUrl} />
                        <p>若是老用户，请点击<span style={{ color: '#feff8c', fontWeight: 'bold' }} onClick={this.toRealname}>【激活设备】</span></p>
                    </div>
                </div > : <div className={styles.wrap} style={{ backgroundImage: `url(${toWeappBj})` }} onClick={this.toWeapp}>
                </div>}
            </>
        )
    }
}
